import * as React from "react";
type Props = {
  className?: string,
};
function SvgLowSugar({ className }: Props) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-LowSugar"
      className={className}
    >
      <path
        d="M29.4308 3V18.893M24.6628 14.3172L29.4048 19.5424L34.1986 14.2602M20.6429 16.9371L17.1857 10.319L11.7164 8.98189L5 13.4855M20.6429 16.9371L14.0922 21.729L8.55412 20.7702L5 13.4855M20.6429 16.9371L15.709 16.082M5 13.4855L8.40253 20.5262L15.709 16.082M5 13.4855L11.4724 9.13349L15.709 16.082M27.7205 22.9783L20.2746 23.5542L16.8798 28.0549L18.3773 36M27.7205 22.9783L29.5385 30.8889L26.4793 35.5988L18.3773 36M27.7205 22.9783L24.9812 27.1805M18.3773 36L26.1981 35.6501L24.9812 27.1805M18.3773 36L16.9311 28.336L24.9812 27.1805"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export default SvgLowSugar;
